import { Route } from '@angular/router';

export const PrescriptionReportPrintRoute: Route = {
  path: '',
  loadChildren() {
    return import(
      '@daas-consulting/production/prescription_report/frontend/routes'
    ).then((c) => c.PrescriptionReportPrintRoutes);
  },
};
